import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    Button,
    makeStyles,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck";
import { obtenerOfertasPaqueteAction, obtenerOfertasPaquetePaginaAction, obtenerOfertasPaqueteRegistrosAction, openEditarOfertaPaqueteAction } from "../../../ducks/ofertasPaqueteDuck";
import { FormatoFechaIso } from "../../../utils/FormatFecha";
import EditIcon from '@material-ui/icons/Edit';
const useStyles = makeStyles({
    container: {
        maxHeight: 250,
    },
    flexCenter: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
})

const TablaOfertas = () => {
    const dispatch = useDispatch()
    const classes = useStyles()
    const { listOfertaPaquete, totalOfertaPaquete, clavePaquete, pagina, registros } = useSelector(store => store.ofertasPaquete)
    const data = listOfertaPaquete ?? []
    const total = totalOfertaPaquete
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerOfertasPaquetePaginaAction({ pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerOfertasPaqueteRegistrosAction({ registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleClick = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerOfertasPaqueteAction({ clavePaquete })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleClickEditar = ({ oferta }) => () => {
        dispatch(openEditarOfertaPaqueteAction({ oferta }))
    }
    if (!data.length) return (
        <div className={classes.flexCenter}>
            <p>No hay datos disponibles</p>
            <Button color="primary" variant="contained" onClick={handleClick}>
                Actulizar
            </Button>
        </div>
    )
    return (
        <Paper>
            <TableContainer className={classes.containe}>
                <Table size="small" stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Descripcion</TableCell>
                            <TableCell align="center">Cantidad</TableCell>
                            <TableCell align="center">Operacion</TableCell>
                            <TableCell align="center">Fecha inicio</TableCell>
                            <TableCell align="center">Fecha fin</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">{row.Descripcion}</TableCell>
                                <TableCell align="center">{row.Cantidad}</TableCell>
                                <TableCell align="center">{(row.Operacion === "*") ? "%" : "$"}</TableCell>
                                <TableCell align="center">{`${FormatoFechaIso({ date: row?.FechaInicio, formato: "dd/MM/yyyy" })}`}</TableCell>
                                <TableCell align="center">{`${FormatoFechaIso({ date: row?.FechaFin, formato: "dd/MM/yyyy" })}`}</TableCell>
                                <TableCell align="center">
                                    <Tooltip title="Editar">
                                        <IconButton onClick={handleClickEditar({ oferta: row })}>
                                            <EditIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 20, 100]}
                component="div"
                count={total}
                rowsPerPage={registros}
                page={pagina}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

export default TablaOfertas